import React, { useMemo, useState, useCallback } from 'react';

import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import { OverlayContext } from 'constants/contexts';
import Overlay from 'components/Overlay';
import { hashStr } from 'utils/string';

function OverlayProvider({ children }) {
  const [data, setData] = useState({});
  const {
    title, body, actions, onClose, hashKey, open,
  } = data;

  const handleClose = useCallback(() => {
    setData((c) => ({ ...c, open: false }));
  }, []);

  const handleOpen = useCallback((params) => {
    setData({
      open: true,
      ...params,
    });
  }, []);

  const contextValue = useMemo(() => [handleOpen, handleClose], [handleOpen, handleClose]);

  return (
    <OverlayContext.Provider
      value={contextValue}
    >
      <Overlay
        open={open}
        onClose={onClose}
        hashKey={hashKey || hashStr(data?.title)}
        sx={{
          zIndex: 1300,
        }}
      >
        <Overlay.Header>{title}</Overlay.Header>
        <Overlay.Content>
          <DialogContentText>{body}</DialogContentText>
        </Overlay.Content>
        <DialogActions>{actions}</DialogActions>
      </Overlay>
      {children}
    </OverlayContext.Provider>
  );
}

export default OverlayProvider;
